import { motion as Motion } from 'motion/react';

// Reveal applies one restrained entrance treatment across content sections.
export function Reveal({ children, className = '', delay = 0, y = 34 }) {
  return (
    <Motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.18 }}
      transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </Motion.div>
  );
}
